import { ORGANIZATION_SEARCH_DIRECTOR_TYPE_PERSONNE_PHYSIQUE } from '../constants/organization-search-api.constant';
import type {
  OrganizationSearchDirector,
  OrganizationSearchDirectorPersonnePhysique,
} from '../types/organization-search-result.type';

export const isPhysicalPersonDirector = (
  director: OrganizationSearchDirector,
): director is OrganizationSearchDirectorPersonnePhysique =>
  director.type_dirigeant ===
    ORGANIZATION_SEARCH_DIRECTOR_TYPE_PERSONNE_PHYSIQUE && !!director.nom;
